const common = {
  id: "ID",
  date: "日期",
  created: "建立日期",
  updated: "更新日期",
  createdBy: "建立者",
  updatedBy: "更新者",
  search: "搜尋",
  archive: "封存",
  type: "類型",
  tags: "標籤",
  remarks: "其他資料",
  sort_order: "排序"
}
const user_fields = {
  ...common,
  "vehicle": "車輛",
  "username": "使用者名稱",
  "api_key": "Api Key",
  "email": "電郵地址",
  "telephone": "電話號碼",
  "mobile": "手提電話號碼",
  "address_1": "地址 1",
  "address_2": "地址 2",
  "firebase_uid": "Firebase Uid",
  "firebase_email": "已連繫電郵地址",
  "firebase_phone": "已連繫電話號碼",
  "role": "類型",
  "release": "發布",
  "expiry": "到期",
  "image_file": "圖片"
};
const admin = {
  resources: {
    "about_us": {
      "name": "關於我們",
      "fields": {
        ...common,
        "image_file": "圖片",
        "content": "內容",
        "url": "網站連結",
        "gmap_url": "谷歌地圖連結"
      }
    },
    "appointment": {
      "name": "預約",
      "fields": {
        ...common,
        "user_id": "使用者",
        "user": "使用者",
        "appointment_type_id": "預約類型",
        "place_id": "地方",
        "vehicle_id": "車輛",
        "datetime": "日期時間",
        "archive": "封存",
        "remarks": "其他資料"
      }
    },
    "document": {
      "name": "附件",
      "fields": {
        ...common,
        "document_type_id": "文件類型",
        "user_id": "使用者",
        "user": "使用者",
        "vehicle_id": "車輛",
        "doc_type": "類型",
        "doc_file": "檔案",
        "doc_date_start": "開始日期",
        "doc_date_end": "結束日期",
        "doc_text": "內文"
      }
    },
    "item": {
      "name": "產品",
      "fields": {
        ...common,
        "supplier_user_id": "供應商",
        "item_category_id": "產品類別",
        "name_en": "名稱 (英文)",
        "name_zh_hk": "名稱 (中文)",
        "desciption_en": "介紹 (英文)",
        "desciption_zh_hk": "介紹 (中文)",
        "price_00": "價錢"
      }
    },
    "item_category": {
      "name": "產品類別",
      "fields": {
        ...common,
        "name_en": "名稱 (英文)",
        "name_zh_hk": "名稱 (中文)",
        "tree_node_parent_id": "Tree Node Parent",
        "tree_node_parent_order": "Tree Node Parent Order",
        "tree_node_level": "Tree Node Level",
        "tree_node_left": "Tree Node Left",
        "tree_node_right": "Tree Node Right"
      }
    },
    "item_inventory": {
      "name": "貨品倉存",
      "fields": {
        ...common,
        "item_id": "產品",
        "place_id": "地方",
        "order_id": "單",
        "quantity": "數量",
        "price_00": "價錢",
        "total_price_00": "總價錢",
        "remarks": "其他資料"
      }
    },
    "maintenance": {
      "name": "保養",
      "fields": {
        ...common,
        "vehicle_id": "車輛",
        "maintenance_status_id": "保養狀態",
        "place_id": "地方",
        "start_date": "開始日期",
        "end_date": "結束日期",
        "archive": "封存"
      }
    },
    "maintenance_details": {
      "name": "保養內容",
      "fields": {
        ...common,
        "place_id": "地方",
        "datetime": "日期時間",
        "remarks": "其他資料",
        "price_00": "價錢",
        "cost_00": "成本",
        "maintenance_id": "保養"
      }
    },
    "motor_vehicle_licence": {
      "name": "車輛牌照",
      "fields": {
        ...common,
        "vehicle_id": "車輛",
        "doc_no": "車輛牌照",
        "doc_licence_expires": "牌照屆滿日期",
        "doc_transaction": "檔案記錄",
        "doc_issue_date": "發出日期"
      }
    },
    "option": {
      "name": "選項",
      "fields": {
        ...common,
        "name_en": "名稱 (英文)",
        "name_zh_hk": "名稱 (中文)",
        "option_type": "選項類型",
        "position": "次序",
        "daily_transaction_type": "日常交易類型"
      }
    },
    "order": {
      "name": "訂單",
      "fields": {
        ...common,
        "order_no": "訂單編號",
        "paid_status": "付款狀態",
        "place_id": "地點",
        "vehicle_id": "車輛",
        "ref_quotation_id": "相關報價單",
        "ref_order_id": "相關銷售單",
        "maintenance_status_id": "維修狀態",
        "quotation_id": "報價單",
        "client_user_id": "客人",
        "sales_user_id": "銷售員工",
        "sales_date": "銷售日期",
        "pickup_date": "提貨日期",
        "total_price": "總價錢",
        "total_paid": "總付款",
        "total_price_00": "總價錢",
        "total_cost_00": "總成本",
        "total_paid_00": "總付款",
        "status": "支付狀態",
        "description": "客戶描述",
        "remarks": "其他資料",
        "invoice_remarks": "發票備註",
      }
    },
    "order_invoice": {
      "name": "訂單發票",
      "fields": {
        ...common,
        "order_id": "訂單",
        "total_price_00": "總價錢",
        "total_paid_00": "總付款",
        "paid_status": "付款狀態",
        "remarks": "其他資料"
      }
    },
    "order_item": {
      "name": "訂單項目",
      "fields": {
        ...common,
        "order_id": "訂單",
        "price_00": "價錢",
        "total_price_00": "總價錢",
        "total_cost_00": "總成本",
        "quantity": "數量",
        "item_id": "產品",
        "vehicle_id": "車輛",
        "original_user_id": "原有使用者",
        "price_trans_00": "賣出價",
        "price_keep_00": "過戶價",
        "price_licence_00": "牌費",
        "price_insurance_00": "保費",
        "price_check_00": "驗車費",
        "price_others_00": "其他費用",
        "price_doc_00": "文件費",
        "selling_cost_00": "賣出價",
        "profit_00": "利潤",
        "commission_00": "佣金",
        "commission_status": "佣金支付狀態"
      }
    },
    "place": {
      "name": "地方",
      "fields": {
        ...common,
        "name_en": "名稱 (英文)",
        "name_zh_hk": "名稱 (中文)"
      }
    },
    "promotion": {
      "name": "推廣",
      "fields": {
        ...common,
        "start_date": "開始日期",
        "end_date": "結束日期",
        "title_en": "標題 (英文)",
        "title_zh_hk": "標題 (中文)",
        "description_en": "內容 (英文)",
        "description_zh_hk": "內容 (中文)"
      }
    },
    "sequential_index": {
      "name": "",
      "fields": {
        ...common,
        "format": "Format",
        "index": "Index"
      }
    },
    "user": {
      "name": "使用者",
      "fields": user_fields
    },
    "technician": {
      "name": "技師",
      "fields": user_fields
    },
    "customer": {
      "name": "客戶",
      "fields": user_fields
    },
    "sales": {
      "name": "銷售人員",
      "fields": user_fields
    },
    "supplier": {
      "name": "供應商",
      "fields": user_fields
    },
    "vehicle": {
      "name": "車輛",
      "fields": {
        ...common,
        "user_id": "使用者",
        "licence_no": "車牌",
        "archive": "封存",
        "base_no": "底盤號碼",
        "doc_registration_mark": "登記號碼",
        "doc_year": "出廠年份",
        "doc_make": "生產商",
        "doc_model": "型號",
        "doc_engine_no": "引擎號碼",
        "doc_colour": "顏色",
        "doc_date_of_first_registration": "首次登記日期",
        "doc_licence_expires": "車牌到期",
        "collected_price_00": "收車價錢",
        "collected_commission_00": "收車佣金",
        "collected_cost_00": "收車成本",
        "doc_cylinder_capacity": "汽缸容量",
        "doc_cylinder_type": "燃料",
        "mileage": "行車里數",
        "prev_owner_count": "前任車主數目",
        "image_file": "圖片"
      }
    },
    "vehicle_sales": {
      "name": "車輛銷售",
      "fields": {
        ...common,
        "buyer_user_id": "購車人",
        "buyer_date": "﻿購車日期",
        "original_user_id": "原車主",
        "original_mobile": "原車主電話",
        "original_doc": "原車主 身份證號/公司註冊證號",
        "collected_price_00": "收車價",
        "collected_cost_00": "其他成本",
        "collected_total_00": "合計車價",
        "collect_status": "支付狀態",
        "original_vehicle_id": "車輛",
        "new_vehicle_id": "車輛",
        "sales_user_id": "銷售員",
        "sales_date": "銷售日期",
        "new_user_id": "買家",
        "new_mobile": "買家電話",
        "new_doc": "買家 身份證號/公司註冊證號",
        "price_00": "賣出價",
        "cost_00": "其他收費",
        "total_00": "合計車價",
        "status": "支付狀態",
        "profit_and_lose_00": "盈虧",
        "remarks": "備註"
      }
    }
  }
}
export default admin;
